/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.grids.events.templates.reorder.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.permissions',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition'
])

.controller('GridsEventsTemplatesReorderController', [
  '$scope',
  '$state',
  '$timeout',
  'ApiService',
  'PermissionsService',
  'HelpersService',
  'CalendarService',
  'NoticeFactory',
  'GridStateFactory',
  'GridDefinitionFactory',
  function($scope,
           $state,
           $timeout,
           ApiService,
           PermissionsService,
           HelpersService,
           CalendarService,
           NoticeFactory,
           GridStateFactory,
           GridDefinitionFactory) {

    $scope.gridsEventsTemplatesReorder = {

      model: [],
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      filtered: [],
      isLoaded: false,
      queryTimer: false,
      searchQuery: '',
      gridName: $state.current.name+'.grid0',
      notice: new NoticeFactory(),
      changes: [],
      hasChanges: false,

      optionsOverride: {
        data: 'gridsEventsTemplatesReorder.model',
        useUiGridDraggableRowsHandle: true,
        useAccessibleGrid: true,
        noUnselect: false,
        showMenu: false,
        draggable: true,
        rowReordering: true,
        appScopeProvider: angular.extend($scope, {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.gridsEventsTemplatesReorder.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns, page) {
            $scope.gridsEventsTemplatesReorder.onDataGridSortChange(grid, columns, page);
          },
          onRowDropped: function (fromIndex, toIndex, draggedEntity) {
            console.log("Dropped", fromIndex, toIndex, draggedEntity);
            $scope.gridsEventsTemplatesReorder.dragTo(draggedEntity.id, fromIndex, toIndex);
          },
          onAfterCellEdit: function(entity, row, toIndex, fromIndex) {
            $scope.gridsEventsTemplatesReorder.moveTo(entity.id, fromIndex, toIndex);
          },
          remove: function (id) {
            $scope.gridsEventsTemplatesReorder.gridRemove(id);
          },
          moveUp: function (id) {
            $scope.gridsEventsTemplatesReorder.moveUp(id);
          },
          moveDown: function (id) {
            $scope.gridsEventsTemplatesReorder.moveDown(id);
          },
          moveToTop: function (id) {
            $scope.gridsEventsTemplatesReorder.moveToTop(id);
          }
        }),
        columnDefs: [
          {
            field: 'displayOrder',
            displayName: 'Drag',
            visible: true,
            width: 50,
            cellNav: false,
            cellTemplate: '<div class="ui-grid-cell-contents grids-events-templates-reorder-drag text-center" data-ng-class="col.colIndex()"><span role="presentation" class="fa fa-bars"><span class="sr-only">Drag</span></span></div>'
          },
          {
            field: 'displayOrder',
            displayName: 'Re-order',
            visible: true,
            width: 50,
            cellTemplate: '<div class="grids-events-templates-reorder-sort" data-ng-class="col.colIndex()"><button role="button" class="fa fa-caret-up btn btn-link" data-ng-click="grid.appScope.moveUp(row.entity.id)"><span class="sr-only">Move Down</span></button><button role="button" class="fa fa-caret-down btn btn-link" data-ng-click="grid.appScope.moveDown(row.entity.id)"><span class="sr-only">Move Up</span></button></div>'
          },
          {
            field: 'displayOrder',
            displayName: 'Display Order',
            visible: true,
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
            enableCellEdit: true,
            enableCellEditOnFocus: true,
            width: 60
          },
          {
            field: 'name',
            displayName: 'Name',
            visible: true
          },
          {
            field: 'displayDescription',
            colId: 'description',
            displayName: 'Description',
            visible: true,
            enableSorting: false
          },
          {
            field: 'move',
            displayName: 'Set as First',
            onCellNavClick: function(row, col) {
              if (row.entity.soldQuantity === 0) {
                $scope.gridsEventsTemplatesReorder.optionsOverride.appScopeProvider.moveToTop(row.entity.id);
              }
            },
            cellTemplate: '<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><button class="grids-events-templates-reorder-top btn btn-link btn-sm" data-ng-click="grid.appScope.moveToTop(row.entity.id)" data-ng-if="row.entity.displayOrder > 1">Set as First</a></div>',
            visible: true,
            enableHiding: false,
            enableSorting: false,
            width: 120
          }
        ]
      },

      init: function() {
        this.changes = [];
        this.gridDefinition.init(this.gridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);

        $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);
        $scope.$on('GridsEventsTemplatesReorderController::Save', this.onSave);
        $scope.$on('GridsEventsTemplatesReorderController::Search', this.onSearch);
        $scope.$on('$destroy', $scope.$watchCollection('gridsEventsTemplatesReorder.changes', this.onChangesUpdate));
      },

      initData: function() {
        var self = $scope.gridsEventsTemplatesReorder, 
            props = self.gridDefinition.getGridState();

        props.sortField = 'displayOrder';
        props.sortDirection = 'asc';
        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getList(self.gridState.getGridState());
      },

      hasItems: function() {
        return (this.model instanceof Array && this.model.length);
      },

      search: function() {
        if (this.queryTimer) {
          $timeout.cancel(this.queryTimer);
        }

        this.queryTimer = $timeout(function () {
          var self = $scope.gridsEventsTemplatesReorder;
          self.gridState.setPropertyValue('search', self.searchQuery);
          $scope.$broadcast('DataGrid::Search', {name: self.gridName});
        }, 500);
      },

      getList: function (gridOptions) {
        ApiService.program.listOrdered(gridOptions).then(this.success.getList, this.error.getList);
      },

      findById: function(id) {
        var i, ii,
          r = false;

        if (this.hasItems()) {
          for (i = 0, ii = this.model.length; i < ii; i++) {
            if (this.model[i].id === id) {
              r = {
                index: i,
                item: this.model[i]
              };
              break;
            }
          }
        }

        return r;
      },

      findByDisplayOrder: function(displayOrder) {
        var i, ii,
          r = false;

        if (this.hasItems()) {
          for (i = 0, ii = this.model.length; i < ii; i++) {
            if (this.model[i].displayOrder === displayOrder) {
              r = {
                index: i,
                item: this.model[i]
              };
              break;
            }
          }
        }

        return r;
      },

      updateChangesItem: function(item) {
        var i, ii,
          found = false;

        for (i=0,ii=this.changes.length;i<ii;i++) {
          if (this.changes[i].id === item.id) {
            this.changes[i] = item;
            found = true;
            break;
          }
        }
        if (!found) {
          this.changes.push(item);
        }
      },

      moveUp: function(id) {
        var target,
            found = this.findById(id);

        if (found) {
          if (found.item.displayOrder > 1) {
            target = this.findByDisplayOrder(found.item.displayOrder - 1);
            found.item.displayOrder -= 1;
            if (target) {
              target.item.displayOrder = found.item.displayOrder + 1;
            }
            this.updateChangesItem(found.item);
          }
        }
      },

      moveDown: function(id) {
        var target,
            found = this.findById(id);

        if (found) {
          if (found.item.displayOrder < this.gridDefinition.totalItems) {
            target = this.findByDisplayOrder(found.item.displayOrder + 1);
            found.item.displayOrder += 1;
            if (target) {
              target.item.displayOrder = found.item.displayOrder - 1;
            }
            this.updateChangesItem(found.item);
          }
        }
      },

      moveToCurrentTop: function(id) {

        var low,
            i, ii,
            found = this.findById(id);

        if (found) {

          low = this.model[0].displayOrder;
          for (i=0,ii=this.model.length;i<ii;i++) {
            low = (low > this.model[i].displayOrder) ? this.model[i].displayOrder : low;
          }

          found.item.displayOrder = low - 1;

          this.model.sort(this.sortModelByDisplayOrder);

          for (i=0,ii=this.model.length;i<ii;i++) {
            this.model[i].displayOrder = low + i;
          }
          this.updateChangesItem(found.item);
        }

      },

      moveToTop: function(id) {
        var found = this.findById(id);

        if (found) {
          // A bit redundant, but it's not handled in moveTo so we're doing a find twice
          this.moveTo(id, found.item.displayOrder, 1);
        }

      },

      moveTo: function(id, fromIndex, toIndex) {
        var targets,
            _to = parseInt(toIndex, 10),
            _from = parseInt(fromIndex, 10),
            found = this.findById(id);

        if (found) {

          if (!isNaN(_to) && _to >= 1 && _to <= this.gridDefinition.totalItems)  {
            this.model[found.index].displayOrder = _to;
            targets = this.model.filter(function(v, i, a) {
              if (v.id !== id && v.displayOrder === _to) {
                return v;
              }
            });
            found.item.displayOrder = _to;
            if (targets.length) {
              targets[0].displayOrder = _from;
            }
            this.updateChangesItem(found.item);
          }else {
            this.model[found.index].displayOrder = _from;
            this.notice.showErrorMessages([{
              message: 'The position <strong>' + toIndex + '</strong> is invalid. Reverting to position <strong>' + fromIndex + '</strong>'
            }]);
            $timeout(function() {
              $scope.gridsEventsTemplatesReorder.notice.hideErrorMessages();
            }, 5000);
          }

        }

      },

      dragTo: function(id, fromIndex, toIndex) {
        var i, ii,
            _from = parseInt(fromIndex, 10),
            _to = parseInt(toIndex, 10),
            adjustBy = (fromIndex > toIndex) ? 1 : -1,
            found = this.findById(id);

        if (isNaN(_from) || isNaN(_to)) {
          this.notice.showErrorMessages([{
            message: 'Invalid position'
          }]);
          return;
        }

        if (found) {

          if (_from > _to) {
            for (i=_to,ii=_from+1;i<ii;i++) {
              this.model[i].displayOrder = this.model[i].displayOrder + adjustBy;
            }
          } else {
            for (i=_from,ii=_to;i<ii;i++) {
              this.model[i].displayOrder = this.model[i].displayOrder + adjustBy;
            }
          }

          if (_to <= 0) {
            found.item.displayOrder = this.model[1].displayOrder - 1;
          } else {
            found.item.displayOrder = this.model[_to-1].displayOrder + 1;
          }

          this.model.sort(this.sortModelByDisplayOrder);

          this.updateChangesItem(found.item);

        }

      },

      sortModelByDisplayOrder: function(a, b) {

        if (a.displayOrder < b.displayOrder) {
          return -1;
        }else if (a.displayOrder > b.displayOrder) {
          return 1;
        }else{
          return 0;
        }

      },

      showChanges: function() {
        this.hasChanges = (this.changes instanceof Array && this.changes.length);
      },

      process: function(list) {
        var i, ii,
            j, jj;

        for (i=0,ii=list.length;i<ii;i++) {
          list[i].displayDescription = (list[i].shortDescription) ? HelpersService.strip(list[i].shortDescription, 80) : HelpersService.strip(list[i].description, 80);
          for (j=0,jj=this.changes.length;j<jj;j++) {
            if (list[i].id === this.changes[j].id) {
              list[i].displayOrder = this.changes[j].displayOrder;
              break;
            }
          }
        }

        return list;
      },

      save: function(e, data) {
        this.notice.hideSuccessMessages();
        this.notice.hideErrorMessages();
        ApiService.program.reorder(this.changes).then(this.success.save, this.error.save);
      },

      success: {
        init: function(response) {},
        save: function(response) {
          var self = $scope.gridsEventsTemplatesReorder;

          self.changes = [];

          $scope.$emit('GridsEventsTemplatesReorderController::Saved');
          self.notice.showSuccessMessages([{
            message: 'Successfully saved'
          }]);
          self.getList(self.gridState.getGridState());

          $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);
        },
        getList: function (response) {
          var self = $scope.gridsEventsTemplatesReorder;

          self.isLoaded = true;
          self.model = self.process(response.data.payload.list);
          self.isLoaded = true;
          self.gridDefinition.isLoaded = true;
          self.gridDefinition.totalItems = response.data.payload.pagination.count;

          if (!$scope.$$phase) {
            $scope.$apply();
          }
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: response.data.payload.pagination.count});
          }, 10);
        }
      },

      error: {
        init: function(response) {},
        save: function(response) {
          var self = $scope.gridsEventsTemplatesReorder;

          self.notice.showErrorMessages([{
            message: response.data.error
          }]);

          $timeout(function() {
            self.notice.hideErrorMessages();
          }, 10000);
        },
        getList: function (response) {}
      },

      onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
        var self = $scope.gridsEventsTemplatesReorder;
        self.gridState.updateGridState(newPage, pageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if (sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }
        self.getList(self.gridState.getGridState());
      },

      onDataGridSortChange: function(grid, columns, page) {
        var self = $scope.gridsEventsTemplatesReorder,
            data = columns[0];
        self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
        self.getList(self.gridState.getGridState());
      },

      onSave: function(e, data) {
        $scope.gridsEventsTemplatesReorder.save();
      },

      onChangesUpdate: function (n, o) {

        var self = $scope.gridsEventsTemplatesReorder;

        self.showChanges();
        self.notice.hideSuccessMessages();
        self.notice.hideErrorMessages();
        $scope.$emit('GridsEventsTemplatesReorderController::Changed', { changed: self.hasChanges, changes: self.changes });

      },

      onSearch: function (e, data) {
        var self = $scope.gridsEventsTemplatesReorder;
        self.searchQuery = data.value;
        self.search();
      }

    };

    $scope.gridsEventsTemplatesReorder.init();

}]);